import { Show } from "shared/components";
import { has } from "shared/utils";
import { VerificationSchemaNames } from "types/landlord/verificationTemplate";
import { Cell } from "views/applications-id/components/ApplicantsTable/components/Cell";
import { ReportStatusBadge } from "views/applications-id/components/ApplicantsTable/components/ReportStatusBadge";
import {
  ApplicantOrInvitee,
  Verification
} from "views/applications-id/components/ApplicantsTable/types";
import { LandLordVerificationStatusBadge } from "../LandLordVerificationStatusBadge";
import { useAuthContext } from "providers/Auth";
import { DataWithAuditFlag } from "./components/DataWithAuditFlag";

export const HousingHistorySection = ({
  applicant,
  verification,
  hasAuditFlagEnabled,
  verificationSchemas
}: {
  verification: Verification;
  hasAuditFlagEnabled: boolean;
  applicant: ApplicantOrInvitee;
  verificationSchemas?: VerificationSchemaNames;
}) => {
  const { permissions } = useAuthContext();

  const auditSummaryFlags =
    "audit_summary_flags" in applicant
      ? applicant.audit_summary_flags
      : undefined;

  return (
    <>
      <Cell
        isDataCell
        className="relative"
        isPermitted={permissions.canAccessReports.housingHistoryReport}
        showRestrictedFlag={!permissions.canAccessReports.housingHistoryReport}
      >
        <DataWithAuditFlag
          hasData={has(verification.summary?.total_number_of_residences)}
          dataValue={verification.summary?.total_number_of_residences ?? null}
          hasAuditFlagEnabled={hasAuditFlagEnabled}
          auditSummaryFlags={auditSummaryFlags}
        />
        <ReportStatusBadge
          applicantStatus={applicant.application_status}
          verificationStatus={verification.status}
          executionMode={verification.settings?.execution_mode}
        />
      </Cell>
      <Cell
        isDataCell
        isPermitted={permissions.canAccessReports.housingHistoryReport}
      >
        <DataWithAuditFlag
          hasData={has(verification.summary?.average_monthly_payment_amount)}
          dataValue={
            has(verification.summary?.average_monthly_payment_amount)
              ? `$${verification.summary.average_monthly_payment_amount}`
              : null
          }
          hasAuditFlagEnabled={hasAuditFlagEnabled}
          auditSummaryFlags={auditSummaryFlags}
        />
      </Cell>
      <Cell
        isDataCell
        isPermitted={permissions.canAccessReports.housingHistoryReport}
      >
        <DataWithAuditFlag
          hasData={has(verification.summary?.total_months_of_residence)}
          dataValue={verification.summary?.total_months_of_residence ?? null}
          hasAuditFlagEnabled={hasAuditFlagEnabled}
          auditSummaryFlags={auditSummaryFlags}
        />
      </Cell>

      <Show if={has(verificationSchemas?.rental_verification)}>
        <Cell
          isDataCell
          isPermitted={permissions.canAccessReports.housingHistoryReport}
        >
          <LandLordVerificationStatusBadge verification={verification} />
        </Cell>
      </Show>
    </>
  );
};
